// ACCORDION / FAQs
//
//
//
//
//
//
export function initAccordion() {


    ///////////////////////////////////////////////
// ACCORDION / FAQs (GSAP) - ACCESSIBLE VERSION
////////////////////////////////////////////////

// Only initialize FAQ accordions if they exist on the page
if (document.querySelectorAll(".faq6_accordion").length > 0) {
    let faqslist = document.querySelectorAll(".faq6_accordion");
  
    faqslist.forEach(faq => {
        const question = faq.querySelector('.faqsquestion');
        const answer = faq.querySelector('.faqsanswer');
        const faqicon = faq.querySelector('.icon-embed-small');
  
        // Set initial state
        gsap.set(answer, { height: '0px', overflow: 'hidden' });
        gsap.set(faqicon, { rotation: 0 });
        question.setAttribute('aria-expanded', 'false');
  
        // Check if this accordion contains the anchor from URL hash
        if (window.location.hash) {
            const hash = window.location.hash.substring(1); // Remove the # symbol
            if (answer.querySelector(`#${hash}`) || answer.querySelector(`[id="${hash}"]`)) {
                openAccordion(question, answer, faqicon);
                
                // Scroll to the anchor after accordion opens
                setTimeout(() => {
                    document.querySelector(`#${hash}`).scrollIntoView({ behavior: 'smooth' });
                }, 350);
            }
        }
  
        // Click handler
        question.addEventListener('click', (e) => {
            e.preventDefault();
            toggleAccordion(question, answer, faqicon);
        });

        // Keyboard handler
        question.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                toggleAccordion(question, answer, faqicon);
            }
        });
    });

    // Helper function to toggle accordion
    function toggleAccordion(question, answer, faqicon) {
        const isExpanded = question.getAttribute('aria-expanded') === 'true';
        
        if (isExpanded) {
            closeAccordion(question, answer, faqicon);
        } else {
            openAccordion(question, answer, faqicon);
        }
    }

    // Helper function to open accordion
    function openAccordion(question, answer, faqicon) {
        gsap.to(answer, { height: answer.scrollHeight + 'px', duration: 0.3, ease: "power2.out" });
        gsap.to(faqicon, { rotation: 45, duration: 0.3, ease: "power2.out" });
        question.setAttribute('aria-expanded', 'true');
    }

    // Helper function to close accordion
    function closeAccordion(question, answer, faqicon) {
        gsap.to(answer, { height: '0px', duration: 0.3, ease: "power2.out" });
        gsap.to(faqicon, { rotation: 0, duration: 0.3, ease: "power2.out" });
        question.setAttribute('aria-expanded', 'false');
    }
  }
  



    // END OF MODULE
    console.log("Accordion initialized");
}